<template>
  <div class="chatbot-landing card border-0 shadow-sm">
    <div class="card-body p-4">

      <!-- HERO SECTION -->
      <div class="row align-items-center mb-4">
        <div class="col-auto">
          <div class="icon-hero">
            <i class="fa fa-comments"></i>
          </div>
        </div>

        <div class="col">
          <h5 class="mb-1 font-weight-bold">
            Waajo AI — Chatbot (Balas Otomatis)
          </h5>
          <p class="text-muted mb-2">
            Tetap responsif kapan pun pelanggan chat, bahkan saat Anda sibuk.
          </p>

          <ul class="hero-bullets pl-3 mb-0">
            <li>Respon instan untuk pelanggan</li>
            <li>Real-time 24 jam saat status Active</li>
            <li>Bisa pakai tombol menu interaktif</li>
          </ul>
        </div>
      </div>

      <!-- TRUST NOTE -->
      <div class="alert alert-warning small mb-4">
        <strong>Penting:</strong>
        Automation berjalan REAL-TIME 24 JAM.
        Selama status <b>Active</b>, sistem langsung membalas pesan masuk.
      </div>

      <!-- CORE FEATURES CARDS -->
      <div class="row text-center mb-4">

        <div class="col-md-4 mb-3">
          <div class="feature-card p-3 h-100">
            <div class="feature-icon mb-2 text-primary">
              <i class="fa fa-user"></i>
            </div>
            <h6 class="font-weight-bold">Pesan Personal</h6>
            <p class="small text-muted mb-2">
              Gunakan variable <code>${first_name}</code>
            </p>
            <div class="code-box small">
              Halo ${first_name}, terima kasih sudah menghubungi kami.
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div class="feature-card p-3 h-100">
            <div class="feature-icon mb-2 text-danger">
              <i class="fa fa-clock-o"></i>
            </div>
            <h6 class="font-weight-bold">Anti Spam</h6>
            <p class="small text-muted">
              Atur Frequency per Person agar tidak kirim berulang.
            </p>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div class="feature-card p-3 h-100">
            <div class="feature-icon mb-2 text-success">
              <i class="fa fa-list"></i>
            </div>
            <h6 class="font-weight-bold">Interactive Menu</h6>
            <p class="small text-muted">
              Tambahkan Kata kunci untuk pilihan pelanggan.
            </p>
          </div>
        </div>

      </div>

      <!-- HOW IT WORKS -->
      <div class="mb-4">
        <h6 class="font-weight-bold mb-2">Cara Kerja Singkat</h6>
        <p class="text-muted small mb-0">
          Saat otomatisasi berstatus Active, sistem akan membalas pesan
          masuk secara real-time 24 jam.
        </p>
      </div>

      <!-- CTA -->
      <!-- <div class="text-center mt-3">
        <a
          href="https://apps.waajo.id/automation/welcome-chat/list"
          target="_blank"
          class="btn btn-primary mr-2"
        >
          Buat Welcome Chat
        </a>

        <a
          href="/spaces/y3yDOx3FFUiYOvvjWbXQ/pages/2ZVbg8NF4VR3gtgAusuh"
          class="btn btn-outline-secondary"
        >
          Pelajari Panduan
        </a>
      </div> -->

    </div>
  </div>
</template>

<script>
export default {
  name: "ChatbotInfoCard"
};
</script>

<style scoped>
.chatbot-landing {
  border-radius: 14px;
}

.icon-hero {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: #eaf3ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #007bff;
}

.hero-bullets li {
  font-size: 13px;
  color: #6c757d;
}

.feature-card {
  border-radius: 10px;
  background: #f8f9fa;
  transition: 0.2s ease;
}

.feature-card:hover {
  background: #eef3ff;
}

.feature-icon {
  font-size: 20px;
}

.code-box {
  background: #fff;
  border: 1px dashed #ddd;
  padding: 6px;
  border-radius: 6px;
  font-family: monospace;
  font-size: 11px;
}
</style>


// WEBPACK FOOTER //
// src/views/ai/chatbot/overview/Information.vue